import { gql } from "urql";
export const CreateHelpRequest = gql `
    mutation CreateHelpRequest($message: String!) {
        helpRequests {
            createHelpRequest(message: $message) {
                success
            }
        }
    }
`;
